export default __webpack_public_path__ + "static/media/vision.970674ce.png";